export const DASHBOARD = 'dashboard';
export const PLAY = 'play';
// export const SUMMARY_DASHBOARD = 'summary';
export const EXCEPTION_RULES = 'exceptionRules';
export const EXCEPTION_ALERT_INSTANCES = 'exceptionAlertInstances';
export const EXCEPTION_ALERT_DEFINITIONS = 'exceptionAlertDefinitions';
export const CONTAINER_TRACKING = 'containerTracking';
export const EXPORTS_CONTAINER_TRACKING = 'exportsContainerTracking';
export const IMPORTS_CONTAINER_TRACKING = 'importsContainerTracking';
export const EXPORTS_RAKE = 'exportsRake';
export const IMPORTS_RAKE = 'importsRake';
export const SALES_ORDER = 'salesOrder';
export const EXPORTS_SALES_ORDER = 'exportsSalesOrder';
export const IMPORTS_SALES_ORDER = 'importsSalesOrder';
export const SETUP_USERS = 'setupUsers';
export const SETUP_TEAMS = 'setupTeams';
export const SETUP_TNC = 'setupTNC';
export const SETUP_CHARGE_MASTER = 'setupChargeMaster';
// export const SETUP_MASTERS = 'setupMasters';
export const SETUP_PERMISSIONS = 'setupPermissions';
export const RFQ_SHIPPER = 'rfqShipper';
export const RFQ_RATE_MASTER = 'rfqRateMaster';
export const RFQ_BULK_REQUEST = 'rfqBulkRequest';
export const RFQ_FLEXIBLE_REPORTS = 'rfqFlexibleReports';
export const RFQ_SHIPPER_OCEAN_FREIGHT = 'rfqShipperOceanFreight';
export const MY_ORGANISATION = 'myOrganisation';
export const RFQ_SHIPPER_ANALYTICS = 'rfqShipperAnalytics';
export const RFQ_SHIPPING_LINE = 'rfqShippingLine';
export const RFQ_VENDOR = 'rfqVendor';
export const IMPORTS = 'imports';
export const EXPORTS = 'exports';
export const AIR_CARGO = 'airCargo';
export const MY_PROFILE = 'myProfile';
export const DOMESTIC_TRACKING = 'domesticTracking';
export const DOMESTIC_CARRIER_MANAGEMENT = 'domesticCarrierManagement';
export const CUSTOMER_ACTIVITY = 'customerActivity';
export const INQUIRY_SHIPPER = 'inquiryShipper';
export const INQUIRY_FF = 'inquiryFF';
export const SHIP_EXEC_SHIPPER = 'executionShipper';
export const SHIP_EXEC_VENDOR = 'executionVendor';
export const MY_FF = 'myFF';
export const MY_SHIPPER = 'myShipper';
export const MY_CHA = 'myCha';
export const MY_CUSTOMER = 'myCustomer';
export const MY_SUPPLIER = 'mySupplier';
export const MY_SHIPPING_LINE = 'myShippingLine';
export const MY_CHILD = 'myChild';
export const LOGOUT = 'logout';
export const PAYABLE = 'payables';
export const RECEIVABLE = 'receivables';
export const RATE_MASTER = 'rateMaster';
export const BULK_REQUEST = 'bulkRequest';
export const DSR_TEMPLATES = 'dsrTemplate';
export const DEMURRAGE_AND_DETENTION = 'demurrage-and-detention';
export const DISCOVER_BUY_RATES = 'discover-buy-rates';
export const DISCOVER_SELL_RATES = 'discover-sell-rates';
export const DISCOVER_RATES = 'discover-rates';
export const MARKUP_AUTOMATION_TOOL = 'markupAutomationTool';
export const PRODUCT = 'products';
export const ADDRESS = 'address';
export const VESSEL_SCHEDULES = 'vessel-schedules';
export const REGIONS = 'regionsTemplate';
export const TRIANGULATION = 'triangulation';
export const INQUIRY_FROM_PROCURE = 'INQUIRY_FROM_PROCURE';
export const USER_MANAGEMENT_WRITE = 'USER_MANAGEMENT_WRITE';
export const MY_SUBSCRIPTION_PLAN = 'subscription-plan';
export const INVOICE = 'invoice';
export const TASKS_WORKFLOW = 'tasks-workflow'
export const PORT_GROUPS = 'port-groups'
export const HOME = '/';

export const API = 'api';
export const ANALYTICS = 'analytics';

export const CUSTOM_CONFIG = 'customConfig';
export const BUSINESS_UNIT = 'businessUnit';

export const MY_DOCUMENTS = 'myDocuments';

export const APPROVAL_POLICIES = 'approvalPolicies';
export const MY_APPROVALS = 'myApprovals';
